import { render, staticRenderFns } from "./SeriesManagement.vue?vue&type=template&id=5dc60b80&scoped=true&"
import script from "./SeriesManagement.vue?vue&type=script&lang=js&"
export * from "./SeriesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc60b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc60b80')) {
      api.createRecord('5dc60b80', component.options)
    } else {
      api.reload('5dc60b80', component.options)
    }
    module.hot.accept("./SeriesManagement.vue?vue&type=template&id=5dc60b80&scoped=true&", function () {
      api.rerender('5dc60b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Series/SeriesManagement.vue"
export default component.exports